/*
by zhou 2016/10/26
 */
"use strict";
angular.module('newWindowPlanDispatchZhuangtaiCtrlModule', [])
    .controller('newWindowPlanDispatchZhuangtaiCtrl', ['$scope', "$modalInstance", "$filter", "Params",
        function($scope, $modalInstance, $filter, Params) {
            initStatus();
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                selectedType();
                $scope.status.windows = angular.copy(Params);
                //在类型无参数传入时,请求任务参数会为undefind,造成参数传入错误,if是进行优化
                if (Params.Canshu.DATA == "无参数配置") {
                    $scope.status.windows.Canshu.CS111 = "";
                    $scope.status.windows.Canshu.CS222 = "";
                    $scope.status.windows.Canshu.CS11 = "";
                    $scope.status.windows.Canshu.CS22 = "";
                    $scope.status.windows.Canshu.CS2 = "";
                    $scope.status.windows.Canshu.CS1 = "";
                }
                //处理新建任务参数与修改任务参数 调用不同服务，返回格式不一样的问题
                if ($scope.status.windows.SCHID === 0) {
                    //  修复 新建任务 后台传入参数为一项时,传入参数不同
                    if (Params.Canshu.CS1 !== "" && Params.Canshu.CS11 === undefined) {
                        $scope.status.windows.Canshu.CS111 = $scope.status.windows.Canshu.CS2;
                        $scope.status.windows.Canshu.CS2="";
                        $scope.status.windows.Canshu.CS222 = "";
                    } else {
                    //  修复 新建任务 后台传入参数为二项时,传入参数不同
                        $scope.status.windows.Canshu.CS111 = $scope.status.windows.Canshu.CS11;
                        $scope.status.windows.Canshu.CS222 = $scope.status.windows.Canshu.CS22;
                        $scope.status.windows.Canshu.CS11 = "";
                        $scope.status.windows.Canshu.CS22 = "";
                    }
                }
                // 修复 修改状态下,后台传入参数为一项
                if (Params.Canshu.CS1 !== "" && Params.Canshu.CS2 === undefined) {
                        $scope.status.windows.Canshu.CS2 = "";
                        $scope.status.windows.Canshu.CS222 = "";
                }
                //处理返回为执行多次情况下，下拉为每天执行多次
                if ($scope.status.windows.SCHMODE == 2) {
                    $scope.data.runmoshi = $scope.data.runmoshiJson[1];
                }
                $scope.title = Params.SCHID === 0 ? "新建任务" : "修改任务";
            }
            /**
             * [selectedType 选择列表参数]
             * @return {[type]} [description]
             */
            function selectedType() {
                $scope.data = {
                    runmoshiJson: [
                        { name: "每天执行一次", value: 1 }, { name: "每天执行多次", value: 2 }
                    ]
                };
                $scope.data.runmoshi = angular.copy($scope.data.runmoshiJson[0]);
            }

            /**
             * [cancel description:取消]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
            /**
             * [confirm description:确定]
             */
            $scope.confirm = function() {
                $scope.status.windows.SDATE = $filter('date')(new Date($scope.status.windows.SDATE), 'HH:mm'); //把执行多次开始时间过滤成 hh:mm
                $scope.status.windows.EDATE = $filter('date')(new Date($scope.status.windows.EDATE), 'HH:mm'); //把执行多次结束时间过滤成 hh:mm
                $scope.status.windows.ETIME = $filter('date')(new Date($scope.status.windows.ETIME), 'HH:mm'); //把执行一次时间过滤成 hh:mm
                //判断执行一次还是执行多次,在执行一次状态下,执行多次的值为空,执行多次状态下,执行一次的值为空,设置间隔时间为param
                if ($scope.data.runmoshi.value == 1) {
                    $scope.status.windows.SDATE = "";
                    $scope.status.windows.EDATE = "";
                    $scope.status.windows.PARAM = 0;
                } else {
                    $scope.status.windows.ETIME = "";
                }
                //判断无参数传入时,设置返回参数为空
                if (Params.Canshu.DATA == "无参数配置") {
                    $scope.status.windows.OPARGS = "";
                } else if (Params.Canshu.CS1 !== "" && Params.Canshu.CS2 === "") {
                    //判断传入参数为一项时,返回参数格式
                    $scope.status.windows.OPARGS = $scope.status.windows.Canshu.CS1 + "=" + $scope.status.windows.Canshu.CS11;
                } else {
                    //传入参数为二项时,返回参数格式
                    $scope.status.windows.OPARGS = $scope.status.windows.Canshu.CS1 + "=" + $scope.status.windows.Canshu.CS11 + "&" + $scope.status.windows.Canshu.CS2 + "=" + $scope.status.windows.Canshu.CS22; //  处理返回参数
                }
                $scope.status.windows.SCHMODE = $scope.data.runmoshi.value; //选择参数的值
                $modalInstance.close($scope.status.windows);
            };
        }
    ]);
